import { useEffect, useState } from "react";
import {
    Accordion,
    AccordionTrigger,
    AccordionContent,
    AccordionItem,
} from "@relume_io/relume-ui";
import { RxPlus } from "react-icons/rx";
import { Button } from "@material-tailwind/react";
import ClipLoader from "react-spinners/ClipLoader";

export const Faq = () => {
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFaqs = async () => {
            try {
                const response = await fetch("/api/faq/GetFAQs"); // replace with your API endpoint
                const data = await response.json();
                setFaqs(data);
            } catch (error) {
                console.error("Failed to fetch FAQs:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchFaqs();
    }, []);

    return (
        <section className="px-[5%] py-16 md:py-24 lg:py-28 bg-gray-50">
            <div className="container">
                <div className="mb-12 text-center max-w-2xl mx-auto">
                    <h2 className="mb-5 text-4xl md:text-6xl font-bold text-gray-900">
                        Frequently Asked Questions
                    </h2>
                    <p className="text-gray-600 md:text-lg">
                        Have questions? We have answers. Here are the most common ones.
                    </p>
                </div>

                {loading ? (
                    <div className="flex justify-center py-12">
                        <ClipLoader size={50} color="#3b82f6" />
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {[0, 1].map((col) => (
                            <Accordion
                                key={col}
                                type="single"
                                collapsible
                                className="flex flex-col gap-4"
                            >
                                {faqs
                                    .filter((_, i) => i % 2 === col) // split FAQs into 2 columns
                                    .map((faq, index) => (
                                        <AccordionItem
                                            key={index}
                                            value={`item-${col}-${index}`}
                                            className="border border-gray-200 bg-white rounded-lg shadow-sm px-5 md:px-6"
                                        >
                                            <AccordionTrigger
                                                className="flex justify-between items-center py-4 text-lg font-medium text-gray-800 [&[data-state=open]>svg]:rotate-45"
                                                icon={
                                                    <RxPlus className="size-6 shrink-0 p-1 text-gray-500 transition-transform duration-300" />
                                                }
                                            >
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: faq.title,
                                                    }}
                                                />
                                            </AccordionTrigger>
                                            <AccordionContent className="text-gray-600 pb-4">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: faq.description,
                                                    }}
                                                />
                                            </AccordionContent>
                                        </AccordionItem>
                                    ))}
                            </Accordion>
                        ))}
                    </div>
                )}

                <div className="mt-16 text-center">
                    <h4 className="mb-3 text-2xl md:text-3xl font-bold text-gray-900">
                        Still have questions?
                    </h4>
                    <p className="text-gray-600 md:text-lg">
                        Don't hesitate to get in touch with us for more details.
                    </p>
                    <div className="mt-6">
                        <a href="/contactus">
                            <Button variant="gradient" color="blue">
                                Contact Us
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
